import vue from 'vue'
import {
  loginForm,
  getLoginCode,
  logout,
  rePwd,
  rePhone,
  getUserInfo,
  editUserInfo, getEnterprise, getRegCode
} from "@/services/login";
import {list} from "@/pages/main/layout/config";
import {Message} from "element-ui";

const state = {
  loginUser: vue.ls.get('loginUser'),
  checkMenu: vue.ls.get('checkMenu'),
  editableTabs: vue.ls.get('editableTabs'),
  identity: 1,
  loginCode: null,
  centerMenu: vue.ls.get('centerMenu'),
  userInfo: {},
  changePassword: false,//修改密码
  changePhone: false,//修改手机号
  basicBool: false,
  loginTips: '',
  dataDetails: {},
};

const getters = {
  loginUser: () => state.loginUser ? state.loginUser : vue.ls.get('loginUser'),
  checkMenu: () => state.checkMenu ? state.checkMenu : vue.ls.get('checkMenu'),
  editableTabs: () => state.editableTabs ? state.editableTabs : vue.ls.get('editableTabs'),
  identity: () => state.identity,
  loginCode: () => state.loginCode,
  centerMenu: () => state.centerMenu ? state.centerMenu : vue.ls.get('centerMenu'),
  userInfo: () => state.userInfo,
  basicBool: () => state.basicBool,
  changePassword: () => state.changePassword,
  changePhone: () => state.changePhone,
  loginTips: () => state.loginTips,
  dataDetails: () => state.dataDetails,
};

const actions = {
  //登录
  loginForm({commit, dispatch}, objc) {
    loginForm(objc.params).then((res) => {
      let {code, msg, data} = res;
      if (res.code == 1) {
        Message.warning(msg);
      }
      if (code == 0) {
        const {productType} = data.user_info;
        let platform = productType ? productType.split(',') : [];

        //todo 判断是否有平台权限
        if (platform.findIndex((i) => i == 2) > -1) {
          commit('updateState', {state: 'loginTips', update: ''});
          //1、存储token(cookie) 2、跳转页面 3、提示登陆成功4、设置选中菜单
          if (objc.cookie) {
            //设置cookie 30分钟失效;
            let time = +new Date() + data.expires_in * 1000;//半个小时后的时间戳
            vue.$cookies.set('tokenTime', time);
            objc.cookie.set('token', data.token_type + ' ' + data.access_token, `${data.expires_in / 60}min`);
            objc.cookie.set('re_token', data.refresh_token, `${data.expires_in / 60}min`);
            objc.cookie.set('access_token', data.access_token, `${data.expires_in / 60}min`);

            if (objc.checked) {
              objc.cookie.set('check', objc.checked);
              //todo 记住账号
              if (objc.params.grant_type == 'app') {
                //记住手机
                objc.cookie.set('mobile', objc.params.mobile);
              }
              if (objc.params.grant_type == 'password') {
                //记住账号密码
                objc.cookie.set('mobile', objc.params.username);
                objc.cookie.set('userInfo', {username: objc.params.username, password: objc.initPwd,});
              }
            } else {
              objc.cookie.remove('userInfo');
              objc.cookie.remove('mobile');
            }
          }

          commit('updateState', {state: 'loginUser', update: data.user_info});

          //todo 处理默认选中菜单
          if (list && list.length > 0) {
            commit('updateState', {state: 'menuTree', update: list});
            //todo 默认选中
            commit('updateState', {state: 'checkMenu', update: list[0].path});
            objc.route.push(list[0].path);
            commit('updateState', {
              state: 'editableTabs',
              update: [{name: list[0].path, title: list[0].name}]
            });
          }

        } else {
          Message.warning('您没有该系统权限，无法登录该系统！');
        }
      }
    })
  },
  //获取验证码
  getLoginCode({commit, dispatch}, objc) {
    getLoginCode(objc).then((res) => {
      if (res.code === 0) {
        if (res.data) {
          commit('updateState', {state: 'loginCode', update: res.data});
        } else {
          Message.warning(res.msg);
        }
      }
    })
  },
  //退出登录
  exitLogin({commit}, objc) {
    logout().then((res) => {
      if (res.code == 0) {
        //1 、退出登陆跳转至登陆页面2、清空本地存储
        if (objc.route) {
          objc.route.push('/');
        }
        if (objc.cookie) {
          //删除cookie，有过期时间没有删除掉
          objc.cookie.remove('token');
        }
        vue.ls.clear();
      }
    })
  },
  //修改手机号
  rePhone({commit, dispatch}, objc) {
    rePhone(objc.params).then((res) => {
      if (res.code === 0) {
        Message.success('手机号修改成功！请重新登录');
        if (objc.route) {
          objc.route.push('/');
        }
      } else {
        Message.warning(res.msg)
      }
    })
  },
  //修改密码
  rePwd({commit, dispatch}, objc) {
    rePwd(objc.params).then((res) => {
      if (res.code === 0) {
        Message.success('密码修改成功！请重新登录');
        if (objc.route) {
          objc.route.push('/');
        }
      } else {
        Message.warning(res.msg)
      }
    })
  },
  getRegCode({commit, dispatch}, objc) {
    getRegCode(objc).then((res) => {
      const {code, data, msg} = res;
      if (code == 0 && data) {
        //获取注册验证码处理
        // commit('updateState', {state: 'code', update: data});
        Message.success('验证码已发送至您的手机，注意查收！');
      } else {
        Message.warning(msg);
      }
    })
  },
  getUserInfo({commit, dispatch}, objc) {
    getUserInfo().then((res) => {
      if (res.code === 0 && res.data) {
        let authorities = [];
        if (res.data && res.data.permissions && res.data.permissions.length > 0) {
          res.data.permissions.map((i) => {
            authorities.push({authority: i});
          })
        }
        commit('updateState', {state: 'loginUser', update: {...res.data.sysUser, authorities}});
        commit('updateState', {state: 'userInfo', update: res.data})
      }
    })
  },

  //编辑用户信息
  editUserInfo({commit, dispatch}, objc) {
    editUserInfo(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'basicBool', update: false})
        Message.success('基本信息修改成功！')
        dispatch('getUserInfo');
      } else {
        Message.warning(res.msg)
      }
    })
  },
  //详情
  getEnterprise({commit, dispatch}, objc) {
    getEnterprise(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataDetails', update: res.data});
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'loginUser' || payload.state === 'checkMenu'
      || payload.state === 'editableTabs' || payload.state === 'centerMenu') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/login/modules/login.js